import { IProfilingCode } from 'legacy/lut/classes/models/profiling/codes'

import { IPartnerFlag } from 'clickNgo/entities/partner/models'
import { Translation } from 'cng-common/features/translations/components/translation'
import { Nullable } from 'cng-common/models/utils'
import { getFormatDate } from 'core/classes/helpers/DateHelper'

import { partnerFlagRequestTranslation } from '../config/translation'

interface IGetWarningMessagesParams {
  profilingCode: IProfilingCode
  inactivePartnerFlag: Nullable<IPartnerFlag>
  isStartDateMoreThanEndDate?: boolean
  isStartDateLessThanCurrent?: boolean
  hasRequiredRole?: boolean
  isRequiredUser?: boolean
}

export const getWarningMessages = ({
  profilingCode,
  inactivePartnerFlag,
  isStartDateMoreThanEndDate,
  isStartDateLessThanCurrent,
  hasRequiredRole,
  isRequiredUser,
}: IGetWarningMessagesParams) => {
  const isSelectedCodeAvailable = hasRequiredRole || isRequiredUser
  const messages = []

  if (!isSelectedCodeAvailable) {
    if (!hasRequiredRole) {
      messages.push(
        <Translation
          htmlAvailable
          text={partnerFlagRequestTranslation.notification.requiredRoles}
          replaceParams={[{ key: '{roles}', value: profilingCode.roles.join(', ') }]}
        />
      )
    }

    if (!isRequiredUser) {
      messages.push(
        <Translation
          htmlAvailable
          text={partnerFlagRequestTranslation.notification.requiredUsers}
          replaceParams={[{ key: '{users}', value: profilingCode.users.join(', ') }]}
        />
      )
    }
  }

  if (inactivePartnerFlag !== null) {
    messages.push(
      <Translation
        htmlAvailable
        text={partnerFlagRequestTranslation.notification.inactivePartnerFlag}
        replaceParams={[
          {
            key: '{startDate}',
            value: getFormatDate(inactivePartnerFlag.startDate, 'date2') || '-',
          },
          { key: '{endDate}', value: getFormatDate(inactivePartnerFlag.endDate, 'date2') || '-' },
        ]}
      />
    )
  }

  if (isStartDateMoreThanEndDate) {
    messages.push(
      <Translation
        htmlAvailable
        text={partnerFlagRequestTranslation.notification.startDateMoreThanEndDate}
      />
    )
  }

  if (isStartDateLessThanCurrent) {
    messages.push(
      <Translation
        htmlAvailable
        text={partnerFlagRequestTranslation.notification.startDateLessThanCurrentDate}
      />
    )
  }

  return messages
}
